import React from 'react'
import { useFormikContext } from 'formik'

import ProfileFormWrapper from 'components/wrappers/ProfileFormWrapper'

import { getCatalogOptions } from 'utils/helpers'
import useAttributes from 'utils/hooks/useAttributes'

import { englishOptions, ProfileFormValues } from '../config'
import { ReactSelect } from 'shared'

const ProfileFormAbout = () => {
  const { values, errors, setValues, setFieldValue } =
    useFormikContext<ProfileFormValues>()

  const { attributes, isLoading } = useAttributes([
    'gender',
    'ethnicity',
    'languages',
    'preferred_pronouns',
    'resident',
  ])

  const { gender, ethnicity, preferred_pronouns, resident } = attributes

  return (
    <ProfileFormWrapper
      title="About me"
      stepDescription="Let's set up your profile. Tell us a bit about yourself."
    >
      <ReactSelect
        name="gender"
        options={getCatalogOptions(gender?.options)}
        value={values.getValueByAttribute(
          'gender',
          'GENERAL',
          values.attributes
        )}
        label="Gender"
        placeholder="Select gender"
        margin="dense"
        isLoading={isLoading}
        onChange={(e) => {
          const catalogItem = gender?.options?.find(
            (item) => item.code === e?.value
          )
          setValues(
            values.setAttributeValue({
              attribute: 'gender',
              category: 'GENERAL',
              value: catalogItem || null,
            })
          )
        }}
        error={errors?.validationErrors?.gender || ''}
      />
      <ReactSelect
        name="preferred_pronouns"
        options={getCatalogOptions(preferred_pronouns?.options)}
        value={values.getValueByAttribute(
          'preferred_pronouns',
          'GENERAL',
          values.attributes
        )}
        label="Preferred pronouns"
        placeholder="Select preferred pronouns"
        margin="dense"
        isLoading={isLoading}
        onChange={(e) => {
          const catalogItem = preferred_pronouns?.options?.find(
            (item) => item.code === e?.value
          )

          setValues(
            values.setAttributeValue({
              attribute: 'preferred_pronouns',
              category: 'GENERAL',
              value: catalogItem || '',
            })
          )
        }}
        error={errors?.validationErrors?.preferred_pronouns || ''}
      />
      <ReactSelect
        isMulti
        name="ethnicity"
        options={getCatalogOptions(ethnicity?.options)}
        value={values.getValuesByAttribute(
          'ethnicity',
          'GENERAL',
          values.attributes
        )}
        label="Ethnicity (select all that apply)"
        placeholder="Select ethnicity"
        margin="dense"
        isLoading={isLoading}
        onChange={(e) => {
          const catalogItems = ethnicity?.options?.filter((item) =>
            e.find((el) => el.value === item.code)
          )
          setValues(
            values.setAttributeValue({
              attribute: 'ethnicity',
              category: 'GENERAL',
              value: catalogItems || null,
            })
          )
        }}
        error={errors?.validationErrors?.ethnicity || ''}
      />
      <ReactSelect
        name="english"
        options={englishOptions}
        value={values.english}
        label="Are you a proficient English speaker? Hue brand partners primarily require video reviews in English"
        placeholder="Select option"
        margin="dense"
        isLoading={isLoading}
        onChange={(e) => {
          setFieldValue('english', e)
        }}
        error={errors?.english || ''}
      />
      <ReactSelect
        name="resident"
        options={getCatalogOptions(resident?.options)}
        value={values.getValueByAttribute(
          'resident',
          'GENERAL',
          values.attributes
        )}
        label="Do you reside in the United States or United Kingdom? You must be US or UK based to participate in Hue campaigns. Hue will not deliver to cargo and freight forwarding companies."
        placeholder="Select option"
        margin="dense"
        isLoading={isLoading}
        onChange={(e) => {
          const catalogItem = resident?.options?.find(
            (item) => item.code === e?.value
          )
          setValues(
            values.setAttributeValue({
              attribute: 'resident',
              category: 'GENERAL',
              value: catalogItem || null,
            })
          )
        }}
        error={errors?.validationErrors?.resident || ''}
      />
    </ProfileFormWrapper>
  )
}

export default ProfileFormAbout
